<template>
    <!-- 食堂档案 -->
    <div class="inside_pages_right_top">
        <ul>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/canteen_data_new'}" @click="$Common.pageJump('/canteen_data_new',3)">食堂信息</li>
            <!-- <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/canteen_data'}" @click="$Common.pageJump('/canteen_data',3)">食堂信息</li>
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/canteen_staff'}"  @click="$Common.pageJump('/canteen_staff',3)" v-if="CanteenId != ''">食堂员工</li> -->
            <li :class="{inside_pages_right_top_action:$Common.getThisTopPage()=='/school_supplier'}" @click="$Common.pageJump('/school_supplier',3)">供应商</li>
        </ul>
    </div>
</template>

<script>
export default {
    name:'CanteenArchives',
    components: {},
    props: {},
    data() {
        return {
            CanteenId:''
        };
    },
    watch: {
    },
    computed: {
    },
    methods: {
       
    },
    created() {
        this.CanteenId = sessionStorage.getItem('schoolCanteenId');
        // console.log(this.CanteenId)
    },
    mounted() {
    },
};
</script>
<style scoped>
@import '/css/base.css';
</style>